// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IResolveBody {
	note: string | undefined;

	$type?: string | undefined;
}
export class ResolveBody {
	constructor(data?: IResolveBody) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	note: string | undefined;

	static $type: string = "CoreApi.Models.Alerts.ResolveBody, ";
	$type?: string | undefined = ResolveBody.$type;
}

